// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1SmNv","containerItemsCenter":"Skeleton_containerItemsCenter__2kSyy"};